import React from 'react';
import { formatRewardDeal, getRewardTerms, money } from '../../utils/loyalty';

export const RedeemModals = ({ selected, open, setOpen, voucher, setVoucher, error, busy, confirm }) => (
  <>
    {open && selected && (
      <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 p-4">
        <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
          <h2 className="text-2xl font-black mb-3">¿Usar este beneficio?</h2>
          <p className="text-gray-600">
            <b>{selected.nombre}</b> por <b>{formatRewardDeal(selected)}</b>.
          </p>
          {getRewardTerms(selected).plata > 0 && (
            <p className="text-sm text-gray-500 mt-3">
              En el local pagás ${money(getRewardTerms(selected).plata)} al presentar el voucher.
            </p>
          )}
          {error && <p className="mt-3 text-sm font-extrabold text-maja-red">{error}</p>}
          <div className="flex gap-3 mt-6">
            <button onClick={() => setOpen(false)} disabled={busy} className="flex-1 h-11 rounded-full bg-gray-100 font-black">
              Cancelar
            </button>
            <button onClick={confirm} disabled={busy} className="flex-1 h-11 rounded-full bg-maja-red text-white font-black">
              {busy ? 'Procesando...' : 'Confirmar'}
            </button>
          </div>
        </div>
      </div>
    )}
    {voucher && (
      <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 p-4">
        <div className="bg-white rounded-2xl p-6 w-full max-w-sm text-center">
          <h2 className="text-2xl font-black text-maja-red mb-2">Voucher listo</h2>
          <p>{voucher.rewardName}</p>
          <p className="font-mono text-3xl font-black my-3 tracking-widest">{voucher.code}</p>
          <p className="font-black text-maja-red">
            {money(voucher.pointsCost)} pts{voucher.plata > 0 ? ` + $${money(voucher.plata)}` : ''}
          </p>
          {voucher.plata > 0 && (
            <p className="text-sm text-gray-500 mt-2">Pagá ${money(voucher.plata)} en el local.</p>
          )}
          <p className="text-sm text-gray-400 mt-2">
            Vence {voucher.expiresAt?.toLocaleDateString?.('es-AR')}
          </p>
          <button onClick={() => setVoucher(null)} className="mt-6 h-11 px-6 rounded-full bg-maja-red text-white font-black">
            Listo
          </button>
        </div>
      </div>
    )}
  </>
);
